import { 
	ifAuthenticated, 
	ifAuthenticatedOnline,
	canAccess,
	AppTabs,
	Edit,
	Show,
	Create,
	Crud,
	trans
} from '@/router/index'

import SendMail from '@/components/common/SendMail'
import SendMultipleMails from '@/components/modules/quotations/SendMultipleMails'
import QuotationsSettings from '@/components/modules/quotations/settings/QuotationsSettings'
import EditQuotationSchedule from '@/components/modules/quotations/settings/EditQuotationSchedule'
import CreateQuotationSchedule from '@/components/modules/quotations/settings/CreateQuotationSchedule'


export const quotations = [
	{
		path: '/quotations',
		beforeEnter: ifAuthenticated,
		component: AppTabs,
		props: {
			tabs: [
				{
					to: '/quotations/',
					text: 'Preventivi',
					model: 'quotation'
				},
			],
		},
		children: [
			{
				path: '/quotations/',
				name: 'quotations-index',
				beforeEnter: (to, from, next) => { ifAuthenticated(to, from, next), canAccess('module', 'quotations', next) },
				component: Crud,
				meta: {
					title: trans('quotations')
				},
				props: {
					modelDef: 'quotations',
					actionIcon: 'library_books',
					title: 'Preventivi',
					styleClass: 'mb-offset',
					enableNumberingAlert: true,
					speedDialOptions: {
						sendMultipleMails: true,
						downloadZip: true
					}
				}
			},
		],
	},
	{ 
		path: '/quotations/create',
		name: 'quotations-create',
		beforeEnter: ifAuthenticatedOnline,
		component: Create,
		meta: {
			title: 'Nuovo Preventivo'
		},
		props: (route) => ({
			modelDef: 'quotations',
			defaultInput: route.params.defaultInput ? route.params.defaultInput : null,
			redirect: route.params.redirect,
			footerComponent: 'footer-product-document-table'
		}),	
	},
	{ 
		path: '/quotations/:id/edit',
		name: 'quotations-edit',
		beforeEnter: ifAuthenticatedOnline,
		component: Edit,
		meta: {
			title: 'Modifica Preventivo'
		},
		props: (route) => ({
			modelDef:  'quotations',
			id: parseInt(route.params.id),
			footerComponent: 'footer-product-document-table'
		}),
	}, 
	{
		path: '/quotations/:id',
		beforeEnter: ifAuthenticatedOnline,
		component: AppTabs, 	
		props: (route) => ({
			tabs: [
				{
					to: '/quotations/' + parseInt(route.params.id) + '/',
					text: 'Preventivo',
				},
			],
		}),
		children: [
			{
				path: '',
				name: 'quotations-show', 
				beforeEnter: ifAuthenticatedOnline,
				component: Show,
				meta: {
					title: 'Preventivo'
				},				
				props: (route) => ({
					id: parseInt(route.params.id),
					modelDef: 'quotations',
					modelClass: 'quotation',
					activities: true,
					fileuploader: true,
					maillogs: true
				}), 
			},
		]
	},
	{ 
		path: '/quotations/send-multiple-mails/',
		name: 'send-multiple-mails',
		beforeEnter: ifAuthenticatedOnline,
		component: SendMultipleMails,
		props: (route) => ({
			selected: route.params.selected
		}), 
	},	
	{ 
		path: '/quotations/quotations-send-mail/:id',
		name: 'quotations-send-mail',
		beforeEnter: ifAuthenticatedOnline,
		component: SendMail,
		props: (route) => ({
			id: parseInt(route.params.id),
			title: 'Invio email Preventivo',
			model_name: 'quotation',
			route: 'quotations'
		}),
	},
	{ 
		path: '/settingsquotations/templates-quotation/create',
		name: 'templates-quotation-create',
		beforeEnter: ifAuthenticatedOnline,
		component: Create,
		props: (route) => ({
			modelDef:  'templates-quotation',
			redirect: route.params.redirect,
			defaultInput: {type: 'quotation'},			
		}),
	},
	{ 
		path: '/settingsquotations/templates-quotation/:id/edit',
		name: 'templates-quotation-edit',
		beforeEnter: ifAuthenticatedOnline,
		component: Edit,
		props: (route) => ({
			modelDef:  'templates-quotation',
			id:  parseInt(route.params.id),
			defaultInput: {type: 'quotation'},
		}), 
	},
	{ 
		path: '/settingsquotations/templates-quotation/:id',
		component: AppTabs, 	
		props: (route) => ({
			tabs: [
				{
					to: '/settingsquotations/templates-quotation/' + parseInt(route.params.id) + '/',
					text: 'Template Preventivo',
				},
			],
		}),
		children: [
			{
				path: '',
				name: 'templates-quotation-show', 
				beforeEnter: ifAuthenticatedOnline,
				component: Show,
				meta: {
					title: 'Template Preventivo'
				},				
				props: (route) => ({
					id: parseInt(route.params.id),
					modelDef:  'templates-quotation',
					modelClass:  'template',
					activities: true
				}), 
			},
		]
	},
	{ 
		path: '/settingsquotations/templates-quotationsign/create',
		name: 'templates-quotationsign-create',
		beforeEnter: ifAuthenticatedOnline,
		component: Create,
		props: (route) => ({
			modelDef:  'templates-quotationsign',
			redirect: route.params.redirect,
			defaultInput: {type: 'quotationsign'},			
		}),
	},
	{ 
		path: '/settingsquotations/templates-quotationsign/:id/edit',
		name: 'templates-quotationsign-edit',
		beforeEnter: ifAuthenticatedOnline,
		component: Edit,
		props: (route) => ({
			modelDef:  'templates-quotationsign',
			id:  parseInt(route.params.id),
			defaultInput: {type: 'quotationsign'},
		}), 
	},

	{ 
		path: '/settingsquotations/templates-quotationsign/:id',
		component: AppTabs, 	
		props: (route) => ({
			tabs: [
				{
					to: '/settingsquotations/templates-quotationsign/' + parseInt(route.params.id) + '/',
					text: 'Template Preventivo Firmato',
				},
			],			
		}),
		children: [
			{
				path: '',
				name: 'templates-quotationsign-show', 
				beforeEnter: ifAuthenticatedOnline,
				component: Show,
				meta: {
					title: 'Template Preventivo Firmato'
				},				
				props: (route) => ({
					id: parseInt(route.params.id),
					modelDef:  'templates-quotationsign',
					modelClass:  'template',
					activities: true
				}), 
			},
		]
	},
	{ 
		path: '/settingsquotations/quotationsmailsschedules/create',
		name: 'quotationsmailsschedules-create',
		beforeEnter: ifAuthenticatedOnline,
		component: CreateQuotationSchedule,
		props: (route) => ({
			modelDef:  'quotationsmailsschedules',
			redirect: {name: 'settingsquotationsscheduling', modelDef: 'quotationsmailsschedules'}
		}),
	},
	{ 
		path: '/settingsquotations/quotationsmailsschedules/:id',
		name: 'quotationsmailsschedules',
		beforeEnter: ifAuthenticatedOnline,
		component: EditQuotationSchedule,
		props: (route) => ({
			modelDef:  'quotationsmailsschedules',
			id:  parseInt(route.params.id),
			redirect: {name: 'settingsquotationsscheduling', modelDef: 'quotationsmailsschedules'}
		}), 
	},
	{ 
		path: '/settingsquotations/',
		name: 'settingsquotations',
		beforeEnter: ifAuthenticatedOnline,
		component: AppTabs,
		props: {
			tabs: [
				{
					to: '/settingsquotations',
					text: 'Preventivi',
				},
			],
		},
		children: [
			{
				path: '/settingsquotations/',
				beforeEnter: ifAuthenticatedOnline,
				component: QuotationsSettings,
			},
		],
	},
]